import React from "react";
import TransferGrid from "../transfer/TransferGrid";
import GraftingProgramGridCard from "../grafting/GraftingProgramGridCard";
import WeightingSingleChart from "../weighting/WeightingSingleChart";
import AnimalModificationList from "../animal-modification-list/AnimalModificationList";
import {SowFeedingCard} from "../../grids/animal-documents/sowFeedingCard/SowFeedingCard";

export default class BoarCard extends React.Component {
    render() {
        const {animal} = this.props;
        return (
            <>
                <SowFeedingCard animal={animal} />
                <WeightingSingleChart />
                <GraftingProgramGridCard />
                <TransferGrid />
                <AnimalModificationList />
            </>
        );
    }
}
